<template>
  <div class="menu-form">

    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  {{$t('category.category')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label" v-show="false">
              <span style="margin-right: 15px;">
                {{$t('category.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.status" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header mb-0">
            <div slot="header">
              <span >
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
            </div>
            <div class="form-group row">
              <legend class="col-sm-2 col-form-label">{{$t('common.uuid')}}</legend>
              <div class="col-sm-7">
                <b-form-input type="text"
                              class="form-control border-radius-4px"
                              :value="uuid"
                              disabled
                  />
              </div>
            </div>
            
            <b-form class="" v-if="item != null">
              <customize-field prefix="category" :update="updateCustomizeField" :item="item" type="category"
                               position="before" element="name_seo"></customize-field>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.category_seo_name')}}</legend>
                <div class="col-sm-10">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.slug"
                    :state="!$v.item.slug.$invalid"
                    :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </div>
              </div>
              <customize-field prefix="category" :update="updateCustomizeField" :item="item" type="category"
                               position="after" element="name_seo"></customize-field>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.name')}}</legend>
                <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                  <b-form-input type="text"
                                :name="`name[${lang}]`"
                                :state="!$v.item.name[lang].$invalid"
                                :aria-describedby="'name-feedback'+lang"
                                class="form-control border-radius-4px"
                                v-model="item.name[lang]"
                                v-bind:placeholder="$t('common.text_' + lang)"
                  />
                 <b-form-invalid-feedback :id="'name-feedback'+lang">
                   <span v-if="!$v.item.name[lang].required">{{ $t('message.required_filed') }}</span>
                   <span v-else-if="!$v.item.name[lang].uniqueCategory">{{ $t('message.category_exist') }}</span>
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.description')}}</legend>
                <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                  <b-form-textarea class="form-control border-radius-4px" v-model="item.description[lang]" :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_' + lang)">
                  </b-form-textarea>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.piece')}}</legend>
                <div>
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.piece" :value="2" :uncheckedValue="1"/>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.hide')}}</legend>
                <div>
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.hide" :value="1" :uncheckedValue="0"/>
                </div>
              </div>
              <div class="form-group row" v-show="checkConfig('list', 'membership_id', 'show')">
                <legend class="col-sm-2 col-form-label">{{$t('category.membership_id')}}</legend>
                <div class="col-sm-10">
                  <b-form-select  class="form-control border-radius-4px"
                                  v-model="item.membership_id"
                                  :options="membership_ids"
                                  v-bind:placeholder="$t('category.membership_id')" />
                </div>
              </div>

              <customize-field prefix="category" :update="updateCustomizeField" :item="item" type="category"
                               position="before" element="level"></customize-field>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.level')}}</legend>
                <div class="col-sm-10">
                  <b-form-select  class="form-control border-radius-4px"
                                  v-model="item.level"
                                  :options="levels[$session.get('lang')]"
                                  v-bind:placeholder="$t('category.level')" />
                </div>
              </div>
              <customize-field prefix="category" :update="updateCustomizeField" :item="item" type="category"
                               position="after" element="level"></customize-field>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">
                  {{$t('category.icon')}}
                  <!-- <i class="fa fa-info-circle text-primary" id="image-icon"></i> -->
                  <b-tooltip target="image-icon" placement="top">
                    <div class="text-left" v-html="getImageHelpInfo('category', 'icon')"></div>
                  </b-tooltip>
                </legend>
                <div class="col-sm-3">
                  <b-form-file class="border-radius-4px" id="iconData" @change="previewIcon" ref="icon" accept="image/*"></b-form-file>
                  <div class="image-desktop-preview">
                    <img class="preview-image" :src="iconData != '' ? iconData : item.image['icon']">
                  </div>
                </div>
                <legend class="col-sm-2 col-form-label text-right">
                  {{$t('category.banner')}}
                  <!-- <i class="fa fa-info-circle text-primary" id="image-banner"></i> -->
                  <b-tooltip target="image-banner" placement="top">
                    <div class="text-left" v-html="getImageHelpInfo('category', 'banner')"></div>
                  </b-tooltip>
                </legend>
                <div class="col-sm-5">
                  <b-form-file class="border-radius-4px" id="bannerData" @change="previewBanner" ref="banner" accept="image/*"></b-form-file>
                  <div class="image-desktop-preview">
                    <img class="preview-image" :src="bannerData != '' ? bannerData : item.image['banner']">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <legend class="col-sm-2 col-form-label">{{$t('category.display')}}</legend>
                <div class="col-sm-5 d-flex">
                  <label class="auto-width col-form-label">{{$t('category.show_on_mobile')}}</label>
                  <div class="full-width flex-1">
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.display_type.mobile"
                      :state="!$v.item.display_type.mobile.$invalid"
                      :aria-describedby="'sequence-feedback'" />
                    <b-form-invalid-feedback :id="'sequence-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="col-sm-5 d-flex">
                  <label class="auto-width col-form-label">{{$t('category.show_on_web')}}</label>
                  <div class="full-width flex-1">
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.display_type.web"
                      :state="!$v.item.display_type.web.$invalid"
                      :aria-describedby="'sequence-feedback'" />
                    <b-form-invalid-feedback :id="'sequence-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
              <div class="form-group row hide">
                <legend class="col-sm-2 col-form-label">{{$t('category.sequence')}}</legend>
                <div class="col-sm-10">
                  <b-form-input
                    class="form-control border-radius-4px"
                    v-model="item.sequence"
                    :state="!$v.item.sequence.$invalid"
                    :aria-describedby="'sequence-feedback'" />
                  <b-form-invalid-feedback :id="'sequence-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="form-group row" v-show="item.level == 1">
                <legend class="col-sm-2 col-form-label">{{$t('category.sub_category')}}</legend>
                <div class="col-sm-10 search-lower-level">
                  <b-input-group>
                    <div class="input-group-prepend">
                      <b-input-group-append>
                        <div class="input-group-text"><i class="fa fa-search" ></i></div>
                      </b-input-group-append>
                    </div>
                    <b-form-select  class="form-control"
                                    v-model="lower_category"
                                    :options="lower_categories[$session.get('lang')]"
                                    v-bind:placeholder="$t('category.sub_category')" />
                  </b-input-group>
                  <div class="full-width">
                    <span class="selected-category" v-for="category in item.lower_categories" :key="category.id" v-if="data_lower_categories['id_'+category.id] != null">
                      {{ data_lower_categories['id_'+category.id].name[$session.get('lang')].trim() }}
                      <span class="close-btn" @click="removeLowerCategory(category.id)">
                        <i class="fa fa-angle-right"></i>
                        <i class="fa fa-angle-left"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </b-form>
            <hr v-if="!isShowSEOConfiguration"/>
             <b-row v-if="!isShowSEOConfiguration">
              <b-col>
                <button type="button" class="btn border-radius-4px bg-main pull-left" v-on:click="cancel()" ><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
                <div class="btn-save">
                  <button type="button" class="btn border-radius-4px bg-main pull-right" v-on:click="saveCategory()" :disabled="checkSubmit()" ><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- SEO Configuration -->
      <seo-configuration v-if="isShowSEOConfiguration" ref="seoConfiguration" :seo-url="categoryUrl" :itemSingle="item"></seo-configuration>
      <div class="new-footer" v-if="isShowSEOConfiguration">
        <button type="button" class="btn border-radius-4px bg-main pull-left" v-on:click="cancel()" ><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
        <div class="btn-save">
          <button type="button" class="btn border-radius-4px bg-main pull-right" v-on:click="saveCategory()" :disabled="checkSubmit()" ><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, email, decimal, or, numeric } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import Multiselect from 'vue-multiselect'
  import SeoConfiguration from '../../../components/Partials/SeoConfiguration'
  let vm = null

  export default {
    name: 'CategoryForm',
    props: {
      uuid: {
        type: String
      },
      existCategory: {
        type: Object
      },
      level: {
      }
    },
    components: {
      Tables,
      cSwitch,
      CustomizeField,
      Multiselect,
      SeoConfiguration
    },
    data: function () {
      return {
        oldCategory: {},
        lower_category: {},
        bannerData: 'https://static.phdvasia.com/jp/banners/banner.jpg',
        iconData: 'https://deo515rx9pz7c.cloudfront.net/fcds/categories/promos.svg',
        customize_option: [
          {
            text: this.$t('category.lunch'),
            value: 'is_lunch'
          }
        ],
        levels: [],
        membership_ids: [],
        lower_categories: [],
        data_lower_categories: [],
        default_item: {
          uuid: '',
          name: {},
          description: {},
          slug: '',
          display_type: {
            mobile: '',
            web: ''
          },
          lower_categories: [],
          lower_category_ids: [],
          customize: {},
          image: {},
          status: 1,
          sequence: 0,
          level: 1,
          piece: 1,
          hide: 0
        },
        item: {
          uuid: '',
          name: {
          },
          description: {},
          slug: '',
          display_type: {
            mobile: '',
            web: ''
          },
          lower_categories: [],
          lower_category_ids: [],
          customize: {},
          image: {},
          status: 1,
          sequence: 0,
          level: 1,
          piece: 1,
          hide: 0,
          membership_id : 0
        },
        category_config : {},
        updateCustomizeField : false,
        isShowSEOConfiguration: false,
        PRODUCT_TILE_LIMIT: 60,
        META_DESCRIPTION_LIMIT: 160,
        clientId: 0,
        itemId: 0,
        categoryUrl: this.$store.getters.config.main.base_site_url
      }
    },
    mixins: [
      validationMixin
    ],
    validations () {
      return {
        item: {
          slug: {
            required
          },
          sequence: {
            required,
            integer
          },
          display_type: {
            mobile: {
              required
            },
            web: {
              required
            }
          },
          name: this.nameRules
        }
      }
    },
    computed: {
      nameRules () {
        let result = {}
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          result[langs[l]] = {
            required,
            uniqueCategory (value) {
              if (!value) {
                return true
              }
              if (this.oldCategory) {
                if (this.oldCategory.hasOwnProperty(langs[l]) && this.oldCategory[langs[l]] && this.oldCategory[langs[l]].toLowerCase() == value.toLowerCase()) {
                 return true
                }
              }
              return this._.indexOf(this.existCategory[langs[l]], value.toLowerCase()) < 0
            }
          }
        }
        return result
      }
    },
    methods: {
      updateSEOUrl () {
        return vm.categoryUrl = `${vm.categoryUrl}/order/${encodeURIComponent(vm.item.slug)}`
      },
      getListMemberShip(){
        let langs = Object.keys(this.$i18n.messages)
        this.axios.customer.getMemberShip(function (response) {
          for(let i of response.data.data.items){
            vm.membership_ids.push({'text': vm.convertMemberNameMemberShip(i),'value':i.id})
          }
          vm.membership_ids.unshift({'text': vm.$t('category.optional', langs[0]), 'value':0})
        })
      },
      convertMemberNameMemberShip(data) {
        let text = '[______]'
        if (data) {
          if (data.hasOwnProperty('name') && data.name) {
            try {
              let lang = vm.$session.get('lang') == 'ja' ? 'ja' : vm.$session.get('lang')
              let obj = typeof data.name === 'string' ? JSON.parse(data.name) : data.name
              text = obj[lang]
            } catch (error) { }
          }
        }
        return text
      },
      resetItem () {
        this.item = {
          uuid: '',
            name: {
          },
          description: {},
          slug: '',
            display_type: {
            mobile: '',
              web: ''
          },
          lower_categories: [],
            lower_category_ids: [],
            customize: {},
          image: {},
          status: 1,
            sequence: 0,
            level: 1
        }
      },
      cancel () {
        this.$emit('cancel')
      },
      removeLowerCategory (id) {
        let lowerCategories = []
        for (let i in vm.item.lower_categories) {
          if (vm.item.lower_categories[i].id != id) {
            lowerCategories.push(vm.item.lower_categories[i])
          }
        }
        vm.item.lower_categories = vm._.cloneDeep(lowerCategories)
        vm.updateLowerCategoryIds()
      },
      updateLowerCategoryIds () {
        vm.item.lower_category_ids = []
        for (let i in vm.item.lower_categories) {
          vm.item.lower_category_ids.push(vm.item.lower_categories[i].id)
        }
      },
      getLowerCategories (level) {
        vm.axios.category.getCategoryListByLevel(level, function (response) {
          vm.lower_categories = []
          vm.data_lower_categories = []
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.lower_categories[langs[l]] = []
            // vm.lower_categories[langs[l]].push({
            //   value: null,
            //   text: vm.$t('category.select_sub_category', langs[l])
            // })
            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
                vm.lower_categories[langs[l]].push({
                  value: item['id'],
                  text: item['name'][langs[l]]
                })
              }
              vm.data_lower_categories['id_' + item['id']] = item
            }
          }
        })
      },
      previewBanner (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this[input.id] = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.item.image['banner'] = input.files[0]
        }
      },
      previewIcon (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this[input.id] = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.item.image['icon'] = input.files[0]
        }
      },
      checkSubmit: function () {
        return vm.$v.item.$invalid
      },
      isJSON: function (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      /**
       * upload image then move to next form
       */
      saveCategory () {
        let item = JSON.parse(JSON.stringify(vm.item))

        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {'Content-Type': 'multipart/form-data'}
        // Process customize items
        let customize = {}
        let fields = []
        if (vm.$store.getters.config.gms.category != null && vm.$store.getters.config.gms.category.fields != null) {
          fields = this.$store.getters.config.gms.category.fields
        }
        for (let i = 0; i < fields.length; i++) {
          let field = fields[i]
          for (let j in field.body) {
            if (field.body[j].name == 'sale_from' || field.body[j].name == 'sale_to') {
              customize[field.body[j].name] = vm.revertDateFormat(vm.item[field.body[j].name])
            } else {
              if(!vm.item[field.body[j].name]) {
                customize[field.body[j].name] = ""
              }else{
                customize[field.body[j].name] = vm.item[field.body[j].name]
              }
            }
          }
        }
        item.customize = vm._.cloneDeep(customize)
        if(vm.isShowSEOConfiguration && !vm.$refs.seoConfiguration.checkRequire()) {
          return
        }
        // just for KW
        let clientUuid = localStorage.getItem('clientID')
        if (vm.isShowSEOConfiguration && clientUuid === vm.client_uuid.kw) {
            let params = vm.$refs.seoConfiguration.getSeoConfigurationParams()
            item.customize['seo_configuration'] = params
        }

        // call an API to save image
        vm.axios.category.uploadCategoryImages(formData, config, function (response) {
          item.image = {}
          for (let i in response.data.data.item) {
            item.image[i] = response.data.data.item[i]
          }
          // get old url
          for (let i in oldUrl) {
            item.image[i] = oldUrl[i]
          }
          vm.imageData = item.image

          let lowerCategoryIds = []

          for (let i in item.lower_category_ids) {
            if (vm.data_lower_categories['id_' + item.lower_category_ids[i]] != null) {
              lowerCategoryIds.push(item.lower_category_ids[i])
            }
          }
          item.lower_category_ids = lowerCategoryIds
          item.lower_categories = lowerCategoryIds
          // save category
          if (vm.uuid === 'create' || vm.uuid === undefined) {
            vm.axios.category.createCategory(item, respone => {
              let newItem = vm._.get(respone, 'data.data.item', {})
              vm.item.uuid = newItem.uuid || ''
              vm.itemId = newItem.id || 0
              vm.$root.$emit('createOrUpdateSEOConfiguration')
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.resetItem()
              vm.$emit('success')
            }, error => {
              vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
              console.log('error', error)
            })
          } else {
            // update category
            vm.axios.category.updateCategory(item, respone => {
              vm.$root.$emit('createOrUpdateSEOConfiguration')
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.resetItem()
              vm.$emit('success')
            }, error => {
              vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
              console.log(error)
            })
          }
        })
      },
      getData () {
        this.oldCategory = {}
        if (vm.uuid === '' || vm.uuid === 'create' || vm.uuid === undefined) {
          vm.item = this._.cloneDeep(vm.default_item)
          vm.item.level = vm.level
          vm.updateCustomizeField = true
          vm.item.membership_id = 0 //default
        } else {
          vm.axios.category.getCategoryDetail(vm.uuid, function (response) {
            if (response.status === 200) {
              vm.item = response.data.data.item
              vm.itemId = vm.item.id
              for (let i in vm.item.customize) {
                vm.item[i] = vm.item.customize[i]
              }
              vm.oldCategory = vm._.cloneDeep(vm.item.name)
              vm.iconData = vm.item.image['icon']
              vm.bannerData = vm.item.image['banner']
              if (vm.item.level != null && vm.item.level > 0) {
                vm.getLowerCategories(vm.item.level + 1)
              }
              if(vm.item.membership_id === null || vm.item.membership_id === undefined){
                vm.item.membership_id = 0 //default
              }
              vm.updateCustomizeField = true
              vm.updateLowerCategoryIds()
              if (vm.isShowSEOConfiguration) {
                vm.$root.$emit('getSeoDetail', vm.item.uuid, vm.item.customize, vm.item)
              }
              vm.updateSEOUrl()
            }
          }, error => {
            console.log('error', error)
          })
        }
      },
      checkConfig(key, value, category) {
        if(this.$store.getters.config.gms.category) {
          this.category_config = this.$store.getters.config.gms.category
          let vm = this
          if (typeof vm.category_config[key] !== 'undefined') {
            let result = vm.category_config[key].filter(obj => {
              return obj.type === value
            })
            if (typeof result[0] !== 'undefined') {
              return result[0][category]
            }
          }
        }
      },
      /**
       * revert date from DD-MM-YYYY to YYYY-MM-DD
       * @param val
       * @returns {*}
       */
      revertDateFormat(val) {
        return this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
    },
    created: function () {
      vm = this
      let langs = Object.keys(this.$i18n.messages)
      for (let l in langs) {
        this.levels[langs[l]] = [
          {text: this.$t('category.master_category', langs[l]), value: 1},
          {text: this.$t('category.sub_category', langs[l]), value: 2}
        ]
      }
      this.getListMemberShip()
      vm.isShowSEOConfiguration = vm.checkConfig('list', 'seo_configuration', 'show')
      vm.clientId = vm._.get(vm.$store.getters.config, 'base.id', 0)
    },
    mounted: function () {
      this.getData()
    },
    watch: {
      lower_category: {
        handler: function (after, before) {
          if (vm.lower_category != '' && vm.lower_category != null) {
            if (vm.item.lower_category_ids.indexOf(vm.lower_category) < 0) {
              vm.item.lower_categories.push(vm.data_lower_categories['id_' + vm.lower_category])
              vm.updateLowerCategoryIds()
            }
          }
        },
        deep: true
      },
      uuid: function(newVal, oldVal) {
        this.getData()
      }
    }
  }
</script>
<style>
  input[type='file'], .custom-file-input, .custom-file-label {
    border-radius: 4px !important;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .switch-title {
    width: auto !important;
  }
  .search-lower-level .input-group-text {
    background: #fff !important;
    border-right: none !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .search-lower-level select {
    border-left: none !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .menu-form .btn-save{
    float: right;
  }
  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .col-form-label {
    padding-right: 10px;
  }

  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }

  #lunch_txt {
    padding-left: 20px;
  }

  .selected-category {
    background: #e1e6eb;
    padding: 7px 10px;
    border-radius: 30px;
    margin-right: 15px;
    color: #000;
    margin-top: 10px;
    float: left;
  }

  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #0091ff;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .preview-image {
    max-width: 100%;
  }
  .new-footer {
    margin-top: 15px;
  }
  .metadata-description {
    margin-top: 0.25rem;
    font-size: 80%;
  }
  .invalid {
    color: #f86c6b;
  }
  .snippet-preview {
    border: 1px solid #e4e5e6;
    padding: 10px;
    height: 100px;
    overflow-y: auto;
  }
  .long-meta-description {
    max-width: 600px
  }
  .snippet-preview-product-title {
    display: inline-block;
    line-height: 1.3;
    margin-bottom: 3px;
    font-family: arial,sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    padding: 0;
    color: #1a0dab;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0,0,0,.1);
  }
  .snippet-preview-meta-description {
    color:#3c4043;
    padding-top: 0;
    margin-bottom: 0;
    text-align: left;
    font-family: arial,sans-serif;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/category/BaseForm.vue